var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex"},[_c('div',{staticClass:"lp-date-picker"},[_c('vue-timepicker',{attrs:{"minuteInterval":5,"value":_vm.time,"format":"HH:mm"},on:{"change":_vm.selTime}}),(_vm.time.HH === '')?_c('i',{staticClass:"material-icons icon-alarm"},[_vm._v("alarm")]):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }